// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Jt-z","tooltipWrapper":"Kt-z","icon":"Lt-z","tooltip":"Mt-z","content":"Nt-z"};